<template>
  <div ref="tablePage" style="height: 100%">
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/homePage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>标签组列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form
          ref="queryForm"
          :model="searchForm"
          inline
          label-width="68px"
          style="margin-left: 8vh"
        >
          <el-form-item style="margin-bottom: 0">
            <el-select
              v-model="searchForm.type"
              placeholder="标签类型"
              clearable
              size="small"
              @clear="clearChange"
              @change="searchChanges"
            >
              <el-option
                v-for="(item, index) in tagTypearr"
                :key="index"
                :label="item.title"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="searchChange"
          size="small"
          >搜索</el-button
        >
        <el-button
          type="success"
          style="margin-left: 2vh"
          icon="el-icon-plus"
          @click="handleNewAdd"
          size="small"
          >新增标签组</el-button
        >
      </div>
    </div>
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>标签组列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button
      type="primary"
      icon="el-icon-plus"
      plain
      @click="handleNewAdd"
      size="mini"
      style="margin-top: 2vh"
      >新增标签组</el-button
    > -->
    <el-table
      :data="tableList"
      style="width: 100%; margin-top: 2vh"
      border
      size="mini"
      :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }"
    >
      <el-table-column prop="sort" label="排序" align="center" />
      <el-table-column prop="title" label="标签组名称" align="center" />
      <el-table-column prop="created_at" label="创建时间" align="center" />
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="handleClick(scope.row)"
            type="primary"
            size="small"
            icon="el-icon-edit"
          >
            修改
          </el-button>
          <el-button
            @click.native.prevent="singleDels(scope.row, scope.row.id)"
            type="danger"
            size="small"
            icon="el-icon-delete"
          >
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="searchForm.page"
      :limit.sync="searchForm.size"
      @pagination="initList"
    />
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="30%"
      class="global-dialog-position"
      :before-close="getout"
    >
      <el-form ref="form" :model="form" label-width="120px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="标签组类型" prop="type">
              <el-select
                v-model="form.type"
                placeholder="标签类型"
                clearable
                @change="searchChange"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in tagTypearr"
                  :key="index"
                  :label="item.title"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="标签组名称" prop="title">
              <el-input
                v-model="form.title"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="form.sort"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="getout">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
import tableCommon from "../../../mixins/table-common";
import {
  getlabelDadList,
  editlabelDad,
  addlabelDad,
  deletelabelDad,
  tagType,
} from "../../api/labelParent";
import { getlabelChildList } from "../../api/labelChild";
export default {
  mixins: [tableCommon],
  data() {
    return {
      // 请求地址api
      api: {
        list: getlabelDadList,
        add: addlabelDad,
        del: deletelabelDad,
        edit: editlabelDad,
      },
      // 规则验证
      rules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
      // 传参
      form: {},
      // 弹窗标题
      title: "新增",
      addOrEditOpen: false,
      // 查询参数
      searchForm: {
        type: 1,
        page: 1,
        size: 10,
      },
      tableData: [],
      tagTypearr: "",
      // 子标签内容
      childArr: [],
    };
  },
  mounted() {
    this.tagTypes();
    this.getlabelChildLists();
  },
  methods: {
    // 删除
    singleDels(param1, param2) {
      this.singleDel(param1, param2);
      // let foundMatch = false;
      
    },
    // 搜索
    searchChanges() {
      this.searchChange();
      this.getlabelChildLists();
    },
    // 获取子标签内容
    getlabelChildLists() {
      getlabelChildList(this.searchForm).then((res) => {
        this.childArr = res.data.records;
      });
    },
    // 清空
    clearChange() {
      this.searchForm.type = undefined;
      this.searchChange();
    },
    // 获取标签类型
    tagTypes() {
      tagType().then((res) => {
        // 获取键和值的数组
        const keys = Object.keys(res.data);
        const values = Object.values(res.data);
        // 创建新的 JSON 数组
        const jsonArr = keys.map((key, index) => {
          return {
            id: parseInt(key),
            title: values[index],
          };
        });

        this.tagTypearr = jsonArr;
      });
    },
    // 重置
    reset() {
      this.form = {
        status: undefined,
        title: undefined,
      };
    },
    // 新增弹窗
    handleNewAdd() {
      this.title = "新增";
      this.reset();
      this.handleAdd();
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    // 修改弹窗
    handleClick(row) {
      this.title = "修改";
      this.form = JSON.parse(JSON.stringify(row));
      this.handleEdit();
    },
    // 关闭弹窗
    getout() {
      this.addOrEditOpen = false;
      this.$refs.form.clearValidate();
    },
  },
};
</script>
<style scoped>
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: Times, "Times New Roman";
  /* font-weight: 600; */
}
.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.navFormWrapper {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/label/labelParent.vue